import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Alert, Container, Text } from '@mantine/core'
import { app, authentication } from '@microsoft/teams-js'

export default function TeamsAuthResult({ result }) {
  const { t } = useTranslation()
  const [error, setError] = useState('')
  useEffect(() => {
    app.initialize().then(() => {
      if (result.error) authentication.notifyFailure(result.error)
      else authentication.notifySuccess(JSON.stringify(result))
    }).catch(() => setError(t("Open deze aanmelding vanuit de Heliview Kanban-tab in Teams.")))
  }, [])
  return <Container size="sm" py="xl">{error || result.error ? <Alert color="red">{t(error || result.error)}</Alert> : <Text>{t("Aangemeld. Je kunt terug naar de Teams-tab.")}</Text>}</Container>
}
